"use client";

import { FaWhatsapp } from "react-icons/fa";

import { createWhatsAppUrl, trackWhatsAppClick } from "./whatsappTracking";

const WHATSAPP_NUMBER = "+919000566767";
// wa.me requires numbers only (no + or spaces)

export default function FloatingWhatsAppButton() {
  const handleClick = () => {
    // GTM event tracking
    trackWhatsAppClick("bottom-left");

    // Open WhatsApp
    window.open(
      createWhatsAppUrl(WHATSAPP_NUMBER),
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="fixed bottom-4 left-4 z-50">
      <button
        onClick={handleClick}
        aria-label="Contact us on WhatsApp"
        className="flex size-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-all hover:scale-110 hover:bg-[#20BA5A] focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2"
      >
        <FaWhatsapp size={28} />
      </button>
    </div>
  );
}
